import { jsxs, jsx } from 'react/jsx-runtime';
import { Box, themedColor, Flex } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import { rgba } from 'polished';
import styled from 'styled-components';
import { backgroundHoverProps, icons } from './shared.esm.js';

/* eslint-disable react/jsx-no-target-blank */ function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: 158px;\n  height: 40px;\n  border-radius: 5px;\n  border: 1px solid ",
        ";\n  ",
        ";\n\n  &:before {\n    width: 100%;\n    height: 100%;\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n    border-bottom: none;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  border-bottom: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var DownloadAppOption = styled(Box)(_templateObject(), themedColor("night"), backgroundHoverProps, icons);
var Wrapper = styled(Flex)(_templateObject2(), function(props) {
    return "solid 1px ".concat(rgba(props.theme.colors.dividerGray, 0.5));
}, MEDIA_QUERIES.tabletAndDesktop(_templateObject1()));
var DownloadLinks = function() {
    return /*#__PURE__*/ jsxs(Wrapper, {
        flexWrap: [
            "wrap",
            "nowrap"
        ],
        gap: "12px",
        justifyContent: [
            "flex-start",
            "space-between"
        ],
        mb: [
            "10px",
            "0px"
        ],
        order: [
            1,
            2,
            2
        ],
        pb: [
            "20px",
            "0px"
        ],
        width: "100%",
        children: [
            /*#__PURE__*/ jsx("a", {
                "aria-label": "Download apple app",
                "data-event": "footer_app_store_clicked",
                href: "https://lemonadeinc.onelink.me/2551691193/84bca19b",
                rel: "noopener",
                target: "_blank",
                children: /*#__PURE__*/ jsx(DownloadAppOption, {
                    spriteLeft: 0,
                    spriteTop: -36
                })
            }),
            /*#__PURE__*/ jsx("a", {
                "aria-label": "Download android app",
                "data-event": "footer_google_play_clicked",
                href: "https://lemonadeinc.onelink.me/2832583367/6a83b39e",
                rel: "noopener",
                target: "_blank",
                children: /*#__PURE__*/ jsx(DownloadAppOption, {
                    spriteLeft: 0,
                    spriteTop: -86
                })
            })
        ]
    });
};

export { DownloadLinks };
